/**
 * A convenience enum of priority levels for flows, events, etc. Lower numbers are higher priorities.
 * Why are they in increments of 100? Inevitably with a prioritized queue we will come to learn that
 * there is a new unit of work that should sit between two units of work with adjacent priorities.
 * If those were priority 2 and 3 in a scale of 1-5, we'd have to adjust our priorities to allow 1-6,
 * shifting everything above what's _now_ a 3 to be one higher.
 * With 100 intervals, it's easy to slot things in without needing to migrate existing queues and historical data.
 */
export var FlowExecutorPriorityLevel;
(function (FlowExecutorPriorityLevel) {
    FlowExecutorPriorityLevel[FlowExecutorPriorityLevel["Highest"] = 100] = "Highest";
    FlowExecutorPriorityLevel[FlowExecutorPriorityLevel["Higher"] = 200] = "Higher";
    FlowExecutorPriorityLevel[FlowExecutorPriorityLevel["High"] = 300] = "High";
    FlowExecutorPriorityLevel[FlowExecutorPriorityLevel["Medium"] = 400] = "Medium";
    FlowExecutorPriorityLevel[FlowExecutorPriorityLevel["Low"] = 500] = "Low";
})(FlowExecutorPriorityLevel || (FlowExecutorPriorityLevel = {}));
//# sourceMappingURL=executorPriorityLevel.js.map